import { ReactNode } from "react";
import mapMarkerIconFactory from "../../../../../common/components/map/marker/map-marker-icon.factory";
import MapMarker from "../../../../../common/components/map/types/map-marker";
import OrderOptimizerDetailsWaypoint from "../../../common/types/order-optimizer-details-waypoint";
import { OrderOptimizerRailyDetailsItemDriver } from "./types/order-optimizer-raily-details-item";

const createMapMarker = (
  points: OrderOptimizerDetailsWaypoint,
  content?: ReactNode
): MapMarker => {
  const icon = mapMarkerIconFactory.createIcon({
    className: "map_marker standard",
    content: content,
  });

  const marker: MapMarker = {
    coordinate: {
      latitude: points.lat,
      longitude: points.lon,
    },
    icon,
  };

  return marker;
};

const createHomeMapMarker = (
  homeAddress: OrderOptimizerRailyDetailsItemDriver,
  content?: ReactNode
): MapMarker => {
  const icon = mapMarkerIconFactory.createIcon({
    className: "map_marker standard",
    content,
  });

  return {
    coordinate: {
      latitude: homeAddress.startLat,
      longitude: homeAddress.startLon,
    },
    icon,
  };
};

const areWaypointsEqual = (
  waypoint1: OrderOptimizerDetailsWaypoint,
  waypoint2: OrderOptimizerDetailsWaypoint
): boolean => {
  return waypoint1.lat === waypoint2.lat && waypoint1.lon === waypoint2.lon;
};

const createMapMarkers = (
  waypoints: OrderOptimizerDetailsWaypoint[],
  hiddenOrders: number[]
): MapMarker[] => {
  let mapMarkers: MapMarker[] = [];

  const indexedWaypoints = waypoints.map((w, index) => ({
    waypoint: w,
    index: index + 1, 
  }));

  for (const waypoint of waypoints) {
    if (hiddenOrders.includes(waypoint.humanId)) {
      continue;
    }

    const allWaypointsOnThisPlace = indexedWaypoints.filter((w) =>
      areWaypointsEqual(w.waypoint, waypoint)
    );

    const signature = allWaypointsOnThisPlace
      .filter((w) => !hiddenOrders.includes(w.waypoint.humanId)) 
      .map((w) => w.index) 
      .join("/");

    const newMarker: MapMarker = createMapMarker(waypoint, signature);

    mapMarkers = [...mapMarkers, newMarker];
  }

  return mapMarkers;
};

const orderOptimizerRailyDetailsMapMarkersFactory = {
  createMapMarkers,
  createHomeMapMarker,
};

export default orderOptimizerRailyDetailsMapMarkersFactory;
